// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const splitPayloadSchema = z.object({
  documents: z.tuple([
    z.object({
      pages: z.array(
        z.object({
          page: urlSchema,
          rotationDeg: z.number().optional(),
        })
      ),
      metadata: z.unknown().optional(),
    }),
  ]),
});

export const splitResponseSchema = z.object({
  results: z.array(
    z.object({
      document: urlSchema,
      annotation: urlSchema,
    })
  ),
});
